import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'input[numbersOnly]'
})
export class NumbersOnlyDirective {

  constructor(private _el: ElementRef, private control: NgControl) { }
  
  numberRegexValidator: RegExp = /^[0-9]+$/;

  @HostListener('input', ['$event']) onInputChange() {
    const currentValue = this._el.nativeElement.value;

    if (this.numberRegexValidator.test(currentValue)) {
      this._el.nativeElement.value = currentValue;
      this.control.control?.setValue(this._el.nativeElement.value);
      return
    }
    // Se descartan todos los caracteres no numéricos,
    // para contemplar el pegado de contenido con caracteres inválidos.
    this._el.nativeElement.value = currentValue.replace(/\D/g, '');
    this.control.control?.setValue(this._el.nativeElement.value);
    return;
  }

}
